import type * as Blockly from 'blockly/core';

export function register(gen: any): void {
    gen.forBlock['float_seven_seg'] = function (block: Blockly.Block): [string, number] {
        const value = block.getFieldValue('NUM') ?? '0.0';
        return [value, 0];
    };
}
